export default __webpack_public_path__ + "static/10_18-da16e93f75a18ff841e139d9f3feb01f.png";